(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["izy-back-to-top"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('izy-back-to-top')) {
    customElements.define('izy-back-to-top', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.button = this.querySelector('button');
        this.frame = null;
        const signal = this.abort.signal;
        const update = () => { this.button.hidden = window.scrollY < Math.max(400, window.innerHeight); };
        this.button.addEventListener('click', () => {
          window.scrollTo({top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
          const main = document.getElementById('main');
          if (main) {
            const temporary = !main.hasAttribute('tabindex');
            if (temporary) main.setAttribute('tabindex', '-1');
            main.focus({preventScroll: true});
            if (temporary) main.removeAttribute('tabindex');
          }
        }, {signal});
        window.addEventListener('scroll', () => {
          if (this.frame !== null) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; update(); });
        }, {passive: true, signal});
        window.addEventListener('resize', update, {passive: true, signal});
        this.stickyObserver?.disconnect();
        const sticky = document.querySelector('product-sticky-bar');
        if (sticky) {
          this.stickyObserver = new ResizeObserver(() => this.button.style.setProperty('--izy-sticky-bar-height', `${sticky.offsetHeight}px`));
          this.stickyObserver.observe(sticky);
        }
        update();
      }
      disconnectedCallback() {
        this.stickyObserver?.disconnect();
        this.abort?.abort();
        if (this.frame !== null) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
